module.exports = __webpack_public_path__ + "static/img/brandirectory.d48a052.png";


//////////////////
// WEBPACK FOOTER
// ./docs/assets/expo/brandirectory.png
// module id = 926
// module chunks = 2 8